var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center",staticStyle:{"float":"left"}},[_c('feather-icon',{attrs:{"icon":"TrashIcon","svgClasses":"h-5 w-5 ml-8 hover:text-danger cursor-pointer"},on:{"click":_vm.confirmDeleteRecord}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }